import { aboutData } from '@/mocks/about';

export default function Reputation() {
  return (
    <section id="reputation" className="px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto text-center">
        <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950 mb-3">
          {aboutData.reputation.title}
        </h2>
        <p className="text-sm md:text-base text-foreground-500 mb-10">
          {aboutData.reputation.subtitle}
        </p>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {aboutData.reputation.stats.map((stat, index) => (
            <div
              key={index}
              className="bg-white rounded-lg p-6 md:p-8"
            >
              <p className="text-3xl md:text-4xl lg:text-5xl font-bold font-heading text-primary-500 mb-2">
                {stat.value}
              </p>
              <p className="text-xs md:text-sm text-foreground-500">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}